/**
 * Maps legacy us_majors.category1 labels → gm_schools.major_categories.name
 * so existing majors_interest_* values still match the dropdown after migration.
 */
export const LEGACY_MAJOR_CATEGORY_TO_GM: Record<string, string> = {
  'Agricultural Sciences': 'Agricultural Sciences',
  'Business and Management': 'Business & Management',
  'Communication and Journalism': 'Communication & Media',
  'Communications Technologies': 'Communication & Media',
  'Computer and Information Sciences': 'Computer Science & Technology',
  'Education and Teaching': 'Education',
  'Engineering Technicians': 'Engineering',
  'Finance and Accounting': 'Business & Management',
  'Food and Nutrition': 'Health Sciences',
  'Health Professions': 'Health Sciences',
  'Legal Professions': 'Law & Legal Studies',
  'Liberal Arts and Humanities': 'Liberal Arts & Sciences',
  'Mechanic and Repair Tech': 'Engineering',
  'Mechanic and Repair Technologies': 'Engineering',
  'Multi/Interdisciplinary Studies': 'Interdisciplinary Studies',
  'Natural Resources and Conservation': 'Environmental Sciences',
  'Parks, Recreation, and Fitness': 'Kinesiology & Movement Studies',
  'Performing Arts': 'Fine Arts',
  'Personal and Culinary Services': 'Interdisciplinary Studies',
  'Physical Sciences': 'Natural Sciences',
  'Precision Production': 'Engineering',
  'Public Administration and Social Services': 'Public Policy & Administration',
  'Science Technologies': 'STEM',
  'Social Sciences and History': 'Social Sciences',
  'Theology and Religious Vocations': 'Philosophy & Religion',
  'Transportation and Materials Moving': 'Engineering',
  'Visual and Performing Arts': 'Fine Arts',
};

export function normalizeMajorCategoryInterest(
  saved: string | undefined,
  options: string[],
): string {
  if (!saved?.trim()) return '';
  const trimmed = saved.trim();
  if (options.includes(trimmed)) return trimmed;
  const mapped = LEGACY_MAJOR_CATEGORY_TO_GM[trimmed];
  if (mapped && options.includes(mapped)) return mapped;
  return trimmed;
}
